import type { ReactNode } from 'react';
import { Dropdown, type SlotDropdownProperties } from 'ui';
import type { SlotStart } from '../../../../types';
import { useCalendarActionsMenu } from '../../../hooks';

type P = {
  children: ReactNode;
  dropdownProps?: SlotDropdownProperties;
  slotStart: SlotStart;
};

const TimeSlotDropdown = ({ children, dropdownProps, slotStart }: P) => {
  const { items, modals } = useCalendarActionsMenu({ slotStart });
  const { menu: dropdownMenu, ...restDropdownProperties } = dropdownProps ?? {};

  return (
    <>
      <Dropdown menu={{ items, ...dropdownMenu }} positionAtClick {...restDropdownProperties}>
        {children}
      </Dropdown>
      {modals}
    </>
  );
};

export default TimeSlotDropdown;
